<h2 mat-dialog-title style="margin:0 0 8px 0;">{{ data.title || 'Confirmation' }}</h2>
<div mat-dialog-content style="font-size: 14px; color: #1f2937;">{{ data.message || 'Are you sure?' }}</div>
<div mat-dialog-actions align="end" style="gap: 8px; margin-top: 6px;">
  <button mat-stroked-button [mat-dialog-close]="false">Cancel</button>
  <button mat-flat-button color="warn" [mat-dialog-close]="true" cdkFocusInitial>Confirm</button>
</div>
